import { render } from "./UnPaidBills.vue?vue&type=template&id=390e55cd&scoped=true"
import script from "./UnPaidBills.vue?vue&type=script&lang=js"
export * from "./UnPaidBills.vue?vue&type=script&lang=js"

import "./UnPaidBills.vue?vue&type=style&index=0&id=390e55cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390e55cd"]])

export default __exports__